import { useCallback, useState } from "react";

export const useSidebarState = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const openSidebar = useCallback(() => setIsSidebarOpen(true), []);
    const closeSidebar = useCallback(() => setIsSidebarOpen(false), []);
    return { isSidebarOpen, openSidebar, closeSidebar };
};
